var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{key:_vm.$route.path})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8dd82468","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./FrontEnd/modulos/relatorio-tecnico-projeto/componentes/RelatorioTecnicoProjeto.vue
// module id = 2175
// module chunks = 0